import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OauthAEMConfig } from '../../models';
import { UtilService } from '../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class IntrospectionService {
  constructor(private http: HttpClient, private utils: UtilService) {}

  async makeIntrospectionCall(
    swapAuthForAccessTokens: string,
    authConfig: OauthAEMConfig
  ) {
    if (swapAuthForAccessTokens) {
      const body = {
        token: swapAuthForAccessTokens,
        client_id: authConfig.INTROSPECTION_CLIENT
      };
      const headers: HttpHeaders = {} as HttpHeaders;
      const data = await this.http
        .post(
          `${this.utils.getPingServiceUrl(authConfig).introspectionUrl}${
            authConfig.INTROSPECTION
          }`,
          body,
          {
            headers: headers,
            responseType: 'json'
          }
        )
        .toPromise();
      return data;
    } else {
      const errorResponse = {
        errors: [{ code: 'ERROR_MSG_21' }]
      };
      return errorResponse;
    }
  }
}
